import React, {useEffect} from 'react';
import YouTube from 'react-youtube';
import ReactPlayer from 'react-player'

const FullScreenVideo = ({toggleMenu, background_video}) => {

    useEffect(() => {
        toggleMenu('close')
    }, [])

    function startVideo(event) {
        event.target.playVideo()
    }

    const opts = {
        height: 'auto',
        width: '100%',
        playerVars: { // https://developers.google.com/youtube/player_parameters
            autoplay: 1,
            loop: 1,
            controls: 1,
            showInfo: 1,
            rel: 0,
            disablekb: 0,
            mute: window.innerWidth > 500 ? 1 : 0,
            playsinline: 1
        }
    };
    let video_id = extractVideoId(background_video);

    if (!video_id) {
        return (
            <div className="homepage-wrapper">
                <div className="video-wrapper"><p style={{marginLeft: 'auto', marginRight: 'auto', width: '50%'}}>De
                    video kon niet worden geladen</p></div>
            </div>
        )
    }
    return (
        <div className="homepage-wrapper">
            <div className="video-wrapper">
                {(!!video_id && video_id.length <= 50) &&
                <YouTube
                    videoId={video_id}
                    id="full_iframe"
                    opts={opts}
                    onEnd={startVideo}
                    onPause={startVideo}
                    onReady={startVideo}
                />
                }

                {(!!video_id && video_id.length > 50) &&
                    <ReactPlayer
                        url={video_id}
                        controls={true}
                        playing={true}
                        config={{
                            options: { autoplay: 1 }
                        }}
                        id="full_iframe"
                        width='100%'
                        height='100%'
                    />
                }

            </div>
        </div>
    )

}

export default FullScreenVideo;

function extractVideoId(url){
    if(!url){
        return null;
    }

    if(url.search('v=') !== -1){
        const video_id = url.split('v=')[1];
        const ampersandPosition = video_id.indexOf('&');
        if (ampersandPosition !== -1) {
            return video_id.substring(0, ampersandPosition);
        }
    }
    return url;
}


